import CartItem from './cart-item';
import { CartItemsListProps } from '../types';

const CartItemsList = ({ lineItems, onUpdateQuantity, onRemove, onAdd }: CartItemsListProps) => {

  const inStockItems = lineItems?.filter((item) => !!item.variant?.isOnStock) ?? [];
  const soldOutItems = lineItems?.filter((item) => !item.variant?.isOnStock) ?? [];

  return (
    <div className="mt-3 divide-y divide-neutral-400 border-t border-neutral-400 lg:mt-8 lg:border-none">
      {inStockItems?.map((lineItem) => (
        <div key={lineItem.lineItemId}>
          <CartItem
            item={lineItem}
            classNames={{ moveToWishlist: 'text-14' }}
            onUndoRemove={() => onAdd(lineItem.variant?.sku as string, lineItem.count ?? 1)}
            onUpdateQuantity={(qty) =>
              qty === 0 ? onRemove(lineItem.lineItemId as string) : onUpdateQuantity(lineItem.lineItemId as string, qty, lineItem.productId)
            }
            onRemove={() => onRemove(lineItem.lineItemId as string)}
          />
        </div>
      ))}

      {soldOutItems?.length > 0 && (
        <div className="border-t border-neutral-400 pt-9">
          <h3 className="text-16 md:text-18 lg:text-22">Sold out</h3>
          <div className="mt-12">
            {soldOutItems.map((lineItem) => (
              <div key={lineItem.lineItemId}>
                <CartItem
                  item={lineItem}
                  classNames={{ moveToWishlist: 'text-14' }}
                  onUpdateQuantity={(qty) =>
                    qty === 0
                      ? onRemove(lineItem.lineItemId as string)
                      : onUpdateQuantity(lineItem.lineItemId as string, qty, lineItem.productId)
                  }
                  onRemove={() => onRemove(lineItem.lineItemId as string)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItemsList;
